import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Avatar, Divider } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ScheduleIcon from '@mui/icons-material/Schedule';
import sample1 from '../assets/images/sample1.jpeg';

const About = () => {
  const team = [
    {
      name: 'Robert Johnson',
      position: 'Founder & Master Electrician',
      bio: 'With over 20 years of experience, Robert leads our team with expertise and dedication to quality.',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
    },
    {
      name: 'Lisa Martinez',
      position: 'Senior Electrician',
      bio: 'Lisa specializes in complex electrical systems and has been with the company for 8 years.',
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
    },
    {
      name: 'Michael Wilson',
      position: 'Commercial Specialist',
      bio: "Michael's expertise in commercial electrical systems helps business clients optimize their electrical infrastructure.",
      avatar: 'https://randomuser.me/api/portraits/men/67.jpg'
    },
    {
      name: 'Jennifer Thomas',
      position: 'Customer Relations Manager',
      bio: 'Jennifer ensures our clients receive exceptional service from initial contact through project completion.',
      avatar: 'https://randomuser.me/api/portraits/women/28.jpg'
    }
  ];

  const values = [
    {
      title: 'Quality Craftsmanship',
      description: 'We take pride in our work and ensure every electrical installation and repair meets the highest standards of quality and safety.',
      icon: <BuildIcon fontSize="large" className="text-gray-700" />
    },
    {
      title: 'Customer Satisfaction',
      description: "Our clients' satisfaction is our top priority. We go above and beyond to exceed expectations and build lasting relationships.",
      icon: <ThumbUpIcon fontSize="large" className="text-gray-700" />
    },
    {
      title: 'Excellence in Service',
      description: 'We strive for excellence in every aspect of our business, from customer service to technical expertise and professional conduct.',
      icon: <EmojiEventsIcon fontSize="large" className="text-gray-700" />
    },
    {
      title: 'Timeliness & Reliability',
      description: 'We value your time and always arrive punctually for appointments, completing projects efficiently without compromising quality.',
      icon: <ScheduleIcon fontSize="large" className="text-gray-700" />
    }
  ];

  return (
    <Box>
      {/* Header */}
      <Box 
        className="py-20 text-white text-center"
        sx={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${sample1})`
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h3" component="h1" className="font-bold mb-4">
            About Davitt Electric
          </Typography>
          <Typography variant="h6" className="max-w-2xl mx-auto">
            Your trusted partner for all electrical services since 2005.
          </Typography>
        </Container>
      </Box>
      
      {/* Company Story */}
      <Box className="py-16">
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h4" component="h2" className="font-bold" sx={{ marginBottom: 'var(--space-lg)' }}>
                Davitt Electric: Your Trusted Electrical Service Provider
              </Typography>
              <Typography variant="body1" className="text-gray-700" sx={{ mt:5 }}>
                At Davitt Electric, we have been providing top-notch electrical services since 2005. Our team of skilled professionals is dedicated to ensuring the highest standards of safety and quality in every project we undertake. Whether it's residential or commercial work, we approach each task with precision and care.
              </Typography>
              <Typography variant="body1" className="text-gray-700" sx={{ mt:5 }}>
                Our commitment to customer satisfaction drives us to exceed expectations. We believe in building lasting relationships with our clients, ensuring that their needs are met with reliability and excellence. Trust us to illuminate your spaces with our expertise and dedication.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="p-4">
                <img 
                  src="https://images.unsplash.com/photo-1581094288338-2314dddb7ece?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" 
                  alt="Our company history" 
                  className="rounded-lg shadow-md w-full"
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      
      {/* Our Values */}
      <Box className="py-16 bg-gray-50">
        <Container maxWidth="lg">
          <Box className="text-center" sx={{ marginBottom: 'var(--space-lg)' }}>
            <Typography variant="h4" component="h2" className="font-bold" sx={{ marginBottom: 'var(--space-md)' }}>
              Our Core Values
            </Typography>
            <Typography variant="body1" className="text-gray-600 max-w-2xl mx-auto">
              These principles guide everything we do at Davitt Electric, from how we train our team 
              to how we interact with our clients.
            </Typography>
          </Box>
          
          <Grid container spacing={4}>
            {values.map((value, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card className="h-full text-center hover:shadow-lg transition-shadow duration-300">
                  <CardContent>
                    <Box className="mb-4 flex justify-center">
                      {value.icon}
                    </Box>
                    <Typography variant="h6" component="h3" className="font-bold mb-2">
                      {value.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {value.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      
      {/* Team Section
      <Box className="py-16">
        <Container maxWidth="lg">
          <Box className="text-center" sx={{ marginBottom: 'var(--space-lg)' }}>
            <Typography variant="h4" component="h2" className="font-bold" sx={{ marginBottom: 'var(--space-md)' }}>
              Meet Our Team
            </Typography>
            <Typography variant="body1" className="text-gray-600 max-w-2xl mx-auto">
              Our team of licensed electricians brings years of experience and dedication to every project.
            </Typography>
          </Box>
          
          <Grid container spacing={4}>
            {team.map((member, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card className="h-full text-center hover:shadow-lg transition-shadow duration-300">
                  <CardContent>
                    <Avatar 
                      src={member.avatar} 
                      alt={member.name}
                      sx={{ width: 120, height: 120 }} 
                      className="mx-auto mb-4"
                    />
                    <Typography variant="h6" component="h3" className="font-bold">
                      {member.name}
                    </Typography>
                    <Typography variant="subtitle2" color="primary" className="mb-2">
                      {member.position}
                    </Typography>
                    <Divider className="my-3" />
                    <Typography variant="body2" color="text.secondary">
                      {member.bio}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box> */}
      
      {/* Certifications */}
      <Box className="py-16 bg-gray-50">
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box className="p-4">
                <img 
                  src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" 
                  alt="Certifications and licenses" 
                  className="rounded-lg shadow-md w-full"
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h4" component="h2" className="font-bold" sx={{ marginBottom: 'var(--space-lg)' }}>
                Certifications & Licenses
              </Typography>
              <Typography variant="body1" className="text-gray-700" sx={{ marginBottom: 'var(--space-lg)' }}>
                We maintain all necessary licenses and certifications, ensuring that our work is always up to code 
                and meets the highest industry standards. Our team regularly participates in continuing education to 
                stay current with the latest electrical codes and technologies.
              </Typography>
              <Typography variant="body1" className="text-gray-700" sx={{ marginBottom: 'var(--space-md)' }}>
                All of our electricians are:
              </Typography>
              <ul className="list-disc pl-5 text-gray-700" sx={{ marginBottom: 'var(--space-lg)' }}>
                <li>Licensed by the state</li>
                <li>Fully insured and bonded</li>
                <li>NEC Code certified</li>
                <li>OSHA safety trained</li>
                <li>Regularly updated on the latest electrical technologies</li>
              </ul>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default About;